module.exports = __webpack_public_path__ + "img/snb_bsgs.a5662fad.svg";